module.exports = __webpack_public_path__ + "static/my-pic-43535207185c5887fdc4a8e8684fe903.jpg";